import {
  Box,
  Typography,
  Container,
  Paper,
  Button,
  Stack,
  Chip,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Checkbox,
  TableBody,
  Avatar,
  IconButton,
  Pagination,
} from "@mui/material";
import {
  CalendarToday as CalendarIcon,
  ArrowUpward as ArrowUpIcon,
} from "@mui/icons-material";
import FilterTable from "./FilterTable";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ListIcon from "@mui/icons-material/List";
import { Trash2, UserRoundPen } from "lucide-react";
import { palette, theme  as colorTheme } from "../../../Convoze.theme";



const primary = colorTheme('palette', 'primary').value;
const pop = colorTheme('palette', 'pop').value;
const positive = colorTheme('palette', 'positive').value;
const neutral = colorTheme('palette', 'neutral').value;
const negative = colorTheme('palette', 'negative').value;



const users = [
  {
    id: 1,
    name: "John Matthews",
    email: "john@acmecorp.com",
    avatar: "/avatar1.png",
    role: "Company Admin",
    company: "Acme Corporation",
    status: "Active",
    lastActive: "Just now",
  },
  {
    id: 2,
    name: "Sarah Johnson",
    email: "sarah@widgetinc.com",
    avatar: "/avatar2.png",
    role: "Company Admin",
    company: "Widget Industries",
    status: "Active",
    lastActive: "2 hours ago",
  },
  {
    id: 3,
    name: "Robert Chen",
    email: "robert@techtron.com",
    avatar: "/avatar1.png",
    role: "QA Analyst",
    company: "TechTron Inc.",
    status: "Active",
    lastActive: "3 hours ago",
  },
  {
    id: 4,
    name: "Michelle Rodriguez",
    email: "michelle@globalservices.com",
    avatar: "/avatar2.png",
    role: "Agent",
    company: "Global Services",
    status: "Active",
    lastActive: "5 hours ago",
  },
  {
    id: 5,
    name: "David Wilson",
    email: "david@starcall.com",
    avatar: "/avatar1.png",
    role: "QA Analyst",
    company: "StarCall Solutions",
    status: "Inactive",
    lastActive: "2 days ago",
  },
];

const getStatusColor = (status) => {
  switch (status) {
    case "Active":
      return "success";
    case "Inactive":
      return "error";
    default:
      return "default";
  }
};

const getRoleColor = (role) => {
  switch (role) {
    case "Company Admin":
      return "primary";
    case "QA Analyst":
      return "secondary";
    case "Agent":
      return "success";
    default:
      return "default";
  }
};

const UserTable = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4 }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 0,
        }}
      >
        <Box>
          <Typography variant="h5" component="h1" fontWeight="bold">
            User Management
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Manage all users across the platform with role-based permissions.
          </Typography>
        </Box>

        <Box>
          <Button
            variant="contained"
            sx={{
              bgcolor: primary,
              borderRadius: 2,
              px: 3,
              height: "40px",
              textTransform: "capitalize",
            }}
          >
            + &nbsp;Add New User
          </Button>
        </Box>
      </Box>
      <Box>
        <FilterTable />
      </Box>
      <Box>
        <Paper
          elevation={1}
          sx={{
            borderRadius: 2,
            height: "100%",
            border: "1px solid #e5e7eb",
            mt: 3,
          }}
        >
          <TableContainer >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>USER</TableCell>
                  <TableCell>ROLE</TableCell>
                  <TableCell>COMPANY</TableCell>
                  <TableCell>STATUS</TableCell>
                  <TableCell>LAST ACTIVE</TableCell>
                  <TableCell>ACTIONS</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {users.map((user) => (
                  <TableRow key={user.id}>
                    <TableCell>
                      <Stack direction="row" alignItems="center" spacing={2}>
                        <Avatar src={user.avatar} />
                        <Box>
                          <Typography fontWeight={600}>{user.name}</Typography>
                          <Typography variant="body2" color="text.secondary">
                            {user.email}
                          </Typography>
                        </Box>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={user.role}
                        color={getRoleColor(user.role)}
                        variant="soft"
                      />
                    </TableCell>
                    <TableCell>
                      <Typography>{user.company}</Typography>
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={user.status}
                        color={getStatusColor(user.status)}
                        variant="soft"
                      />
                    </TableCell>
                    <TableCell>
                      <Typography>{user.lastActive}</Typography>
                    </TableCell>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        {/* <IconButton color="primary">
                          <ListIcon />
                        </IconButton> */}
                        <IconButton color="primary">
                          <UserRoundPen />
                        </IconButton>
                        <IconButton color="error">
                          <Trash2 />
                        </IconButton>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Box
              p={2}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography>Showing 1 to 10 of 256 users</Typography>
              <Pagination count={26} page={1} color="primary" />
            </Box>
          </TableContainer>
        </Paper>
      </Box>
    </Container>
  );
};

export default UserTable;
